<template>
  <div>
    <navlist :navlist="about" />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />特色
        </h1>
        <h2 v-if="local.name">{{local.name}}</h2>
      </div>
      <div class="main">
        <p>理想城社区居委会——一个年轻而富有朝气的社区。2016年，这里陆续迎来了“新湖州人”，他们来自周边农村拆迁安置、来自外来经商、务工人员、来自上海、杭州退休老人。在这个大家庭中，他们互助互爱，为了美好生活的共同理想“抱团”，“三融三爱三服务”的新时代理想城特色党建由此启航。</p>
        <p>理想城党支部成立于2018年10月，是街道最新的支部之一，她把27名党员紧紧聚在一起。在党建引领下，62名家园志愿者全力参与组建了6支志愿者队伍，先后诞生了家园先锋、家园卫士、家园文工、家园园丁、家园医生、家园顾问等一批特色鲜明的专业化队伍。</p>
        <p>船行须水流，顺水推舟去。在理想城设计的党建航道中，“三个三”为其锚定坐标、形成涓流。</p>
        <p>
          “三融”：党建融入社区治理、党建融入民生点滴、党建融入区块联动
          “三爱”：爱家庭、爱邻里、爱社区
          “三服务”：服务发展、服务党员、服务群众
        </p>
        <ul class="charact-list">
          <router-link tag='li' to='/character/dtail/green' style="background:#ff6261;">三融</router-link>
          <router-link tag='li' to='/character/dtail/red' style="background:#49cf54;">三爱</router-link>
          <router-link tag='li' to='/character/dtail/blue' style="background:#2fc4d8;">三服务</router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "../components/nav";
export default {
  components: {
    navlist
  },
  data() {
    return {
      about: [
        {
          path: "/character",
          name: "社区特色"
        }
      ],
      local:{}
    };
  }
};
</script>

<style>
.charact-list{
  display: flex;
}
.charact-list li{
  margin-right: 50px;
  width: 300px;
  height: 300px;
  background: yellow;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 28px;
  box-shadow: 0 5px 10px rgba(0,0,0,0.5); 
}
</style>